export default "__VITE_ASSET__Bx9LDwvR__"